const accessToken = localStorage.getItem("kcb_app_token");
export const Auth = {
  state: { accessToken: accessToken, otp: false },
  getters: {
    getOtp(state) {
      return state.otp;
    },
  },
  actions: {
    setToken({ commit }, accessToken) {
      commit("accessToken", accessToken);
    },
    setOtp({ commit }, data) {
      commit("setOtp", data);
    },
  },
  mutations: {
    accessToken(state, accessToken) {
      state.accessToken = accessToken;
    },
    setOtp(state, otp) {
      state.otp = otp;
    },
  },
};